import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
// import Poster from '../poster/poster';
import { setElementClass } from '../../../utils/create_class_list_util';
import NewsletterSubscriber from './newsletter_subscriber';
import ReCaptcha from './recaptcha';

class NewsletterSignup extends NewsletterSubscriber {
  shouldComponentUpdate(nextProps, nextState) {
    const { state } = this;
    const hasError = nextState.error;
    const hasStatusChange = nextState.message !== state.message;
    const isLoading = nextState.disabled !== state.disabled;
    const hasEmailInputChange = nextState.email !== state.email;
    const shouldDisplayCaptchaChange =
      this.state.shouldDisplayReCaptcha !== nextState.shouldDisplayReCaptcha;
    return (
      hasError ||
      hasStatusChange ||
      isLoading ||
      hasEmailInputChange ||
      shouldDisplayCaptchaChange
    );
  }

  render() {
    const { assignedNewsletters, id, isAdvertorial } = this.props;
    const currentSite = this.props.config.site;
    const isPost = this.props.modifier === 'post';
    const regex = new RegExp(/co-design$/, 'i');
    const coDesignFlag = regex.test(get(this.props, 'sectionPath', ''));

    const newsletterTitle =
      get(this.props, 'title') ||
      `${get(assignedNewsletters, '[0].listName')} Newsletter`;
    const newsletterDeck = get(this.props, 'deck')
      ? ` ${get(this.props, 'deck')}`
      : ` ${get(assignedNewsletters, '[0].message')}`;
    // const metadata = {
    //   title: 'Newsletter Signup',
    //   featured_image: { source: this.props.poster },
    //   noLazy: true,
    //   assetSizes: imageSizesLookup[3]
    // };

    return (
      <form
        onSubmit={this.handleSubmit}
        className={`newsletter-signup newsletter-signup--${
          this.props.modifier
        }`}
      >
        <div
          className={`newsletter-signup__container${
            isAdvertorial ? ' newsletter-signup__container--advertorial' : ''
          }`}
        >
          {/* {this.props.poster ? <Poster metadata={metadata} /> : ''} This doesn't really work too well and is a very confusing component, no matter what image you provide it sets the to width: 33vw which is NOT good */}

          {coDesignFlag ? (
            <img
              className="newsletter-signup__poster"
              src="https://assets.fastcompany.com/image/upload/c_scale,w_289/v1605552418/co-design-logo-neg-2020_2x.png"
              alt=""
            />
          ) : (
            <img
              className="newsletter-signup__poster"
              src="https://assets.fastcompany.com/image/upload/v1605724147/compass-logo-neg_2x.png"
              alt=""
            />
          )}
          <p className="newsletter-signup__copy">
            <strong
              className={
                isPost
                  ? setElementClass('newsletter-signup', 'copy-title--post')
                  : setElementClass('newsletter-signup')
                  // : setElementClass('newsletter-signup', coDesignClassName) // this is undefined.. dunno who wrote it, but define the variable "coDesignClassName".
              }
            >
              {coDesignFlag
                ? 'Design inspiration in your inbox.'
                : newsletterTitle}
            </strong>
            <br />
            <span
              className={
                coDesignFlag
                  ? setElementClass(
                      'newsletter-signup',
                      '__copy-title--newsletterDeckCoDesign'
                    )
                  : setElementClass(
                      'newsletter-signup',
                      '__copy-title--newsletterDeck'
                    )
              }
            >
              {' '}
              {isPost ? '' : newsletterDeck}{' '}
            </span>
          </p>
          <input
            className={`newsletter-signup__input
              ${this.state.error ? 'newsletter-signup__input--error' : ''}
              ${this.state.status ? 'newsletter-signup__input--success' : ''}
              ${this.state.disabled ? 'newsletter-signup__input--loading' : ''}
              `}
            name="email"
            type="email"
            onFocus={this.handleInputFocus}
            onChange={this.handleEmailUpdate}
            value={this.state.email}
            disabled={this.state.disabled}
            placeholder={
              get(this.statusMessages, [this.state.status]) ||
              'YOUR EMAIL ADDRESS'
            }
          />
          <input type="hidden" name="listId" value="573" />
          {this.state.shouldDisplayReCaptcha ? (
            <div className="newsletter-signup__recaptcha">
              <ReCaptcha
                verifyCallback={this.handleVerify}
                id={id || 'fastcompanyhomepage'}
              />
            </div>
          ) : (
            ''
          )}
          <br />
          <button
            className={`newsletter-signup__button ${
              isPost ? 'newsletter-signup__button--post' : ''
            } newsletter-signup__button--${currentSite}
              ${coDesignFlag ? 'newsletter-signup__coDesignButton' : ''}
              ${this.state.disabled ? 'newsletter-signup__button--loading' : ''}
              `}
            disabled={this.state.disabled}
          >
            Sign Up
          </button>
          <a
            href="//www.fastcompany.com/newsletters"
            className="newsletter-signup__newsletter-page-link"
          >
            See All Newsletters
          </a>
          {this.props.hideCheckBox || get(assignedNewsletters, 'length') < 2 ? (
            ''
          ) : (
            <div className="newsletter-signup__checkbox-option">
              <div className="newsletter-signup__checkbox-container">
                <div className="newsletter-signup__checkbox-wrapper">
                  <input
                    className="newsletter-signup__checkbox"
                    type="checkbox"
                    id="special-offers"
                    name={get(assignedNewsletters, '[1].listId')}
                    onChange={this.handleUpdate}
                    defaultChecked={true}
                  />
                </div>
                <label
                  className="newsletter-signup__label"
                  htmlFor="special-offers"
                >
                  {get(assignedNewsletters, '[1].message')}
                </label>
              </div>
            </div>
          )}
        </div>
      </form>
    );
  }
}

NewsletterSignup.defaultProps = {
  modifier: '',
  poster: '',
  hideCheckBox: false,
  id: '',
  isAdvertorial: false
};

NewsletterSignup.propTypes = {
  modifier: PropTypes.string,
  currentSite: PropTypes.string.isRequired,
  assignedNewsletters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  poster: PropTypes.string,
  hideCheckBox: PropTypes.bool,
  isAdvertorial: PropTypes.bool,
  id: PropTypes.string
};

function mapStateToProps(state, ownProps) {
  const newslettersConfig = get(state, 'config.newsletters');
  const newslettersBySlug = get(newslettersConfig, 'listsBySlug');
  const newsletterDictionary = get(newslettersConfig, 'listsById');

  const assignedNewsletters = ownProps.newsletters;
  return {
    config: state.config,
    currentSite: state.config.site,
    assignedNewsletters: assignedNewsletters.map(
      function processAssignedNewsletters(newsletter) {
        const newsletterNameProp = newsletter.list;
        const listId = get(newslettersBySlug, newsletterNameProp);
        const found = newsletterDictionary[listId];
        return {
          listName: get(found, 'listName'),
          listId,
          message: get(found, 'short')
        };
      }
    )
  };
}

export default connect(mapStateToProps)(NewsletterSignup);
